import type { ToolboxQuestionI } from "../../../../../types";

export type QuestionType = ToolboxQuestionI["type"];

export const QUESTION_TYPE_LABELS: Record<string, string> = {
  input: "Input",
  multiple_choice: "Multiple Choice",
  rating_scale: "Rating Scale",
};

export const QUESTION_TYPES = Object.keys(QUESTION_TYPE_LABELS);

export function getNewQuestionContent(type: string): Record<string, unknown> {
  switch (type) {
    case "input":
      return { label: "", placeholder: "" };
    case "multiple_choice":
      return { label: "", choices: ["", ""], msq: false };
    case "rating_scale":
      return { label: "", scale: 5 };
    default:
      return { label: "" };
  }
}

function newVariableName(): string {
  return `q_${crypto.randomUUID().replace(/-/g, "_")}`;
}

export function getNewQuestion(type: QuestionType = "input"): ToolboxQuestionI {
  return {
    questionId: crypto.randomUUID(),
    variableName: newVariableName(),
    type,
    content: getNewQuestionContent(type),
  } as ToolboxQuestionI;
}
